<template>
  <header class="header">
    <div>
      <img
        class="header_img"
        :src="logoUrl"
        alt="魅TV" />
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  setup (props, { emit }) {
    const {
      LOGO_URL
    } = window.__CONFIG__

    return {
      logoUrl: LOGO_URL
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  width: 100%;

  &_img {
    width: 100%;
    vertical-align: bottom;
  }
}
</style>
